import { useTranslation } from "react-i18next";

export function ForbiddenPage() {
  const { t } = useTranslation("auth");

  return (
    <section className="flex flex-col gap-2">
      <h1 className="text-xl font-semibold">{t("forbidden.title")}</h1>
      <p className="text-muted-foreground text-sm">
        {t("forbidden.description")}
      </p>
    </section>
  );
}
